/** @format */

import {ReactElement} from 'react';

import {Theme} from '@mui/material/styles';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import ChangeHistoryIcon from '@mui/icons-material/ChangeHistory';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';

import {SensorSeverity} from '../../..';

export const getSensorIcon = (theme: Theme, severity?: SensorSeverity): ReactElement => {
  if (severity === 'red') {
    return (
      <CropSquareIcon
        sx={{
          fontSize: 16,
          color: theme.palette.semantic_dark?.bad.main,
        }}
      />
    );
  }

  if (severity === 'yellow') {
    return (
      <ChangeHistoryIcon
        sx={{
          fontSize: 16,
          color: theme.palette.semantic_dark?.tertiary.main,
        }}
      />
    );
  }

  return (
    <CircleOutlinedIcon
      sx={{
        fontSize: 16,
        color: theme.palette.figma_surface?.light,
      }}
    />
  );
};

